export const serviceData = [
  {
    name: "PR Services",
    description:
      "Strategic public relations, media relations, brand positioning, and crisis management for impactful brand narratives.",
    icon: "megaphone-outline",
  },
  {
    name: "TV Entertainment",
    description:
      "Creative television content production, entertainment programming, talent management, and audience engagement solutions.",
    icon: "tv-outline",
  },
  {
    name: "Corporate Communications",
    description:
      "Professional internal and external communication strategies that strengthen corporate identity and stakeholder relationships.",
    icon: "business-outline",
  },
  {
    name: "Fintech",
    description:
      "Innovative financial technology solutions designed to enhance digital payments, security, and seamless customer experiences.",
    icon: "card-outline",
  },
  {
    name: "Distribution Services",
    description:
      "Efficient product distribution, logistics coordination, and supply chain support for reliable market delivery.",
    icon: "cube-outline",
  },
  
  {
    name: "Event Management",
    description:
      "End-to-end event planning, coordination, and execution services that deliver memorable and professionally managed experiences.",
    icon: "calendar-outline",
  },
  {
    name: "Celebrity Endorsement",
    description:
      "Strategic celebrity partnerships and influencer collaborations that boost brand visibility, trust, and audience engagement.",
    icon: "star-outline",
  },
  {
    name: "ICT",
    description:
      "Reliable ICT solutions including technology support, digital infrastructure, software systems, and business automation services.",
    icon: "desktop-outline",
  },
];